import AuthForgotPasswordAPI from '@/app/apis/auth/auth-forgot-password/auth-forgot-password-api.js';

export default {
  /**
   * @param {*} userDetails
   */
   async postAuthForgotPass(userDetails) {
		return AuthForgotPasswordAPI.postAuthForgotPass(userDetails);
   }
}